import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { demoUser } from '@/providers/apis/demo-user/demo-user';
import { sessionService } from '@/providers/services/auth/session';
import axios from 'axios';
import { authAPI } from '@/providers/apis/auth/auth';
import { isAPICatchError } from '@/utils/utils';
import { appConfigService } from '@/providers/services/app/app-config';

@Component({
  name: 'role-list',
  components: {
    'material-icon': GoogleMaterialIcon,
  },
})

export default class RoleList extends Vue {

  // -------------------------------------------------------------------------
  // Properties

  /**
   * Holding all the user roles data
   */
  private roleList: any = [];

  @Prop()
  private appList?: any;

  private get session() {
    return sessionService.getDemoSessionCopy()
            ? sessionService.getDemoSessionCopy() : sessionService.getSession();
  }

  private get isDemoUser() {
    return this.$access.hasPermission(this.$access.menus.nav, this.$access.ACL.roleView)
              || sessionService.getDemoSessionCopy()
              || this.$access.hasPermission(this.$access.menus.all, this.$access.ACL.all);
  }

  private appId: string | null = appConfigService.getAdminUiAppId();

  /**
   * Help to handle show current user option in menus
   */
  private get showCurrentUser() {
    const role = sessionService.getSession();
    return role ? role.username : this.roleList[0].username;
  }

  // -------------------------------------------------------------------------
  // Hooks

  private created() {
    axios.all([
      demoUser.fetchDemoAccounts(),
    ]).then(axios.spread((roles) => {
      let superUser: any = {};
      superUser = {
           username: this.session ? this.session.username : 'Super User',
           name: 'Super User',
           code: 'DEMO_USER',
         };
      const userExist = roles.find((items: any) => items.username === superUser.username);
      this.roleList = userExist ? roles : [...[superUser], ...roles];
    }));
  }

  // ---------------------------------------------------------------------------------
  // Actions

  /**
   *
   * @param role it has selected role details
   */
  private onChangeRole(role: any) {
    if (role.code !== 'DEMO_USER') {
      this.$access.doLoginInWithCredential(role);
      return;
    }
    const session = sessionService.getDemoSessionCopy();
    if (session) {
      this.$access.updateRole(session);
    }
  }

  private onChangeAppList(selectedApp: any) {
    const lanuchUrl = selectedApp.lanuchUrl;
    authAPI.setImpersonateToken(this.session.access_token).then((data: any) => {
      if (!isAPICatchError(data)) {
        window.open(`${lanuchUrl}/?am=st`);
      }
    });
  }

  // ------------------------------------------------------------------------
  // Methods

}
